import * as React from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { useRefinementList, useClearRefinements } from 'react-instantsearch';
import { ButtonDropdown } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useDebouncedEffect } from '@grandvisionhq/utils';
import { filterFacetOption } from '../../utils/filter-facet-option.js';
import { orderFacetOptions } from '../../utils/order-facet-options.js';
import { ClearFacetFilter } from '../ClearFacetFilter/ClearFacetFilter.js';
import FacetContainer from '../FacetContainer/FacetContainer.js';
import { FacetSearchBox } from '../FacetSearchBox/FacetSearchBox.js';
import RefinementItem from '../RefinementItem/RefinementItem.js';

const facetInputItemVariants = {
    flip: {
        transition: {
            type: 'spring',
            stiffness: 500,
            damping: 800
        }
    }
};
function ConnectedFacetInputList({ facet , searchable , attribute , limit  }) {
    const { getLabel  } = useIntl();
    const { isFromSearch , searchForItems , items , refine  } = useRefinementList({
        attribute,
        limit
    });
    const { refine: clearRefine  } = useClearRefinements({
        includedAttributes: [
            attribute
        ]
    });
    const [state, setState] = React.useState('');
    const refineCount = items.filter((item)=>item.isRefined
    ).length;
    const sortedItems = React.useMemo(()=>orderFacetOptions({
            facet,
            items
        }).filter((item)=>filterFacetOption(item, facet)
        )
    , [
        facet,
        items
    ]);
    useDebouncedEffect(()=>searchForItems(state)
    , 200, [
        state
    ]);
    const ariaLabel = `${getLabel('search.filterBy')} ${getLabel(facet.labelKey || facet.id).toLowerCase()}`;
    if (!items.length && !isFromSearch) {
        return null;
    }
    var _label;
    return /*#__PURE__*/ React.createElement(ButtonDropdown, {
        focusItemOnHover: false,
        loop: true,
        "aria-label": ariaLabel,
        className: "connected-facet-input-list"
    }, /*#__PURE__*/ React.createElement(ButtonDropdown.Button, {
        popupType: "dialog",
        className: "connected-facet-input-list__button"
    }, (_label = facet.label) !== null && _label !== void 0 ? _label : getLabel(facet.labelKey || facet.id)), /*#__PURE__*/ React.createElement(ButtonDropdown.Content, {
        type: "generic",
        restoreFocus: true
    }, /*#__PURE__*/ React.createElement(FacetContainer, {
        SearchButton: searchable ? /*#__PURE__*/ React.createElement(ButtonDropdown.InteractiveWrapper, {
            childElement: "input"
        }, /*#__PURE__*/ React.createElement(FacetSearchBox, {
            placeholder: getLabel('search.filters.placeholder'),
            onSearch: (event)=>setState(event.target.value)
        })) : undefined,
        ClearButton: /*#__PURE__*/ React.createElement(ButtonDropdown.InteractiveWrapper, {
            isDisabled: refineCount <= 0,
            childElement: "button"
        }, /*#__PURE__*/ React.createElement(ClearFacetFilter, {
            onClear: clearRefine,
            isDisabled: refineCount <= 0,
            label: getLabel('search.filters.clear', {
                defaultValue: 'clear'
            })
        })),
        title: /*#__PURE__*/ React.createElement(React.Fragment, null, refineCount, ' ', getLabel('search.filters.selected', {
            defaultValue: 'selected'
        }))
    }, /*#__PURE__*/ React.createElement(AnimatePresence, null, sortedItems.map((item)=>/*#__PURE__*/ React.createElement(ButtonDropdown.InteractiveWrapper, {
            key: item.label,
            childElement: "input"
        }, /*#__PURE__*/ React.createElement(motion.div, {
            variants: facetInputItemVariants,
            key: item.label
        }, /*#__PURE__*/ React.createElement(RefinementItem, {
            key: item.label,
            item: item,
            facet: facet,
            onRefine: refine
        })))
    )))));
}

export { ConnectedFacetInputList };
//# sourceMappingURL=ConnectedFacetInputList.js.map
